// ** Types
import type { SearchResult, SearchSuggestion } from '@/components/common/MegaMenuOverlay/megaMenuOverlay.types';
import type { SearchOption } from '@/components/common/searchSection/types';

export const AP07_MEGA_MENU_SEARCH_FILTER_TYP_OPTIONS: SearchOption[] = [
	{ value: 'all', label: 'Alle Typen' },
	{ value: 'bericht', label: 'Bericht' },
	{ value: 'download', label: 'Download' },
	{ value: 'news', label: 'News' },
	{ value: 'podcast', label: 'Podcast' },
	{ value: 'seite', label: 'Seite' },
	{ value: 'veranstaltung', label: 'Veranstaltung' },
	{ value: 'video', label: 'Video' }
];

export const AP07_MEGA_MENU_SEARCH_FILTER_THEMA_OPTIONS: SearchOption[] = [
	{ value: 'all', label: 'Alle Themen' },
	{ value: 'ausbildung', label: 'Ausbildung' },
	{ value: 'digitalisierung', label: 'Digitalisierung' },
	{ value: 'fachwissen', label: 'Fachwissen' },
	{ value: 'fortbildung', label: 'Fortbildung' },
	{ value: 'mitgliedschaft', label: 'Mitgliedschaft' },
	{ value: 'nachhaltigkeit', label: 'Nachhaltigkeit' },
	{ value: 'recht', label: 'Recht & Steuern' },
	{ value: 'strategie', label: 'Strategie' },
	{ value: 'veranstaltungen', label: 'Veranstaltungen' }
];

export const AP07_MEGA_MENU_SEARCH_SUGGESTIONS: SearchSuggestion[] = [
	{ id: '1', label: 'Strategie' },
	{ id: '2', label: 'Strategieberatung' },
	{ id: '3', label: 'Strategieplanung' },
	{ id: '4', label: 'Tischler NRW Mitgliedschaft' },
	{ id: '5', label: 'Fortbildung' },
	{ id: '6', label: 'Veranstaltungen' },
	{ id: '7', label: 'Digitalisierung Handwerk' },
	{ id: '8', label: 'Ausbildung Tischler' },
	{ id: '9', label: 'Nachhaltigkeit Holz' },
	{ id: '10', label: 'CAD Vorlagen Download' }
];

const IMG_A = '/images/mega-menu/search-result-test-1.png';
const IMG_B = '/images/mega-menu/search-result-test-2.png';

const LOREM =
	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.';

const LONG_EXCERPT =
	'Die strategische Ausrichtung eines Handwerksbetriebs über mehrere Jahre hinweg erfordert eine fundierte Analyse von Markt, Kostenstrukturen und Personalentwicklung. ' +
	'Dieser Absatz ist absichtlich sehr lang, damit du im Overlay prüfen kannst, wie die Karte mit viel Fließtext umgeht: Zeilenumbruch, Kürzung nach vier Zeilen auf dem Smartphone und nach zwei Zeilen auf dem Desktop, sowie die vertikale Verteilung zwischen Bild, Textblock und Fußzeile mit CTA. ' +
	'Noch ein Satz: Wenn der Inhalt weiter wächst, sollte der Kartenrahmen stabil bleiben und der Körpertext nicht über die Karte hinauslaufen — sondern sauber mit Ellipse enden. ' +
	'Und zum Schluss: Wiederholung für Länge. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Cras mattis consectetur purus sit amet fermentum.';

export const AP07_MEGA_MENU_SEARCH_RESULTS: SearchResult[] = [
	{
		id: 'dev-long-text',
		title: '[Sehr langer Titel für Suchkarten-Test',
		category: 'Unternehmensentwicklung',
		date: '26.03.2026',
		excerpt: LONG_EXCERPT,
		typeLabel: 'Seite',
		imageSrc: IMG_A,
		href: '#dev-long-text-card'
	},
	{
		id: '1',
		title: 'Strategieberatung — Übersicht',
		category: 'Strategieberatung',
		date: '23.03.2026',
		excerpt: LOREM,
		typeLabel: 'Seite',
		imageSrc: IMG_A
	},
	{
		id: '2',
		title: 'Neu: Förderprogramme 2026 für Betriebe',
		category: 'Aktuelles',
		date: '22.03.2026',
		excerpt:
			'Kurzüberblick zu neuen Förderfenstern, Antragsfristen und Beratungsangeboten der Landesinnung — ideal für die schnelle Orientierung im Büro.',
		typeLabel: 'News',
		imageSrc: IMG_B
	},
	{
		id: '3',
		title: 'Strategische Planung im Handwerk',
		category: 'Publikationen',
		date: '20.03.2026',
		excerpt:
			'Leitfaden zur strategischen Planung für mittelständische Betriebe im Handwerk — von der Analyse bis zur Umsetzung.',
		typeLabel: 'Seite',
		imageSrc: IMG_A
	},
	{
		id: '4',
		title: 'Mitgliedschaft — Leistungen und Tarife',
		category: 'Mitgliedschaft',
		date: '18.03.2026',
		excerpt:
			'Welche Services, Versicherungen und Netzwerkangebote die Mitgliedschaft abdeckt und wie der Beitritt Schritt für Schritt funktioniert.',
		typeLabel: 'Seite',
		imageSrc: IMG_B
	},
	{
		id: '5',
		title: 'Fortbildung: Arbeitssicherheit in der Werkstatt',
		category: 'Fortbildung',
		date: '15.03.2026',
		excerpt: 'Präsenztermin mit Referenten der BG — Anmeldung verbindlich, begrenzte Plätze für Gesellen und Meister.',
		typeLabel: 'Veranstaltung',
		imageSrc: IMG_A
	},
	{
		id: '6',
		title: 'CAD-Paket Schränke & Türen (ZIP)',
		category: 'Downloads',
		date: '12.03.2026',
		excerpt: 'Vorlagen für gängige Systeme, Metadaten und Nutzungshinweise. Nur für Mitglieder nach Login verfügbar.',
		typeLabel: 'Download',
		imageSrc: IMG_B
	},
	{
		id: '7',
		title: 'Podcast: Gespräch mit Landesmeisterin',
		category: 'Medien',
		date: '10.03.2026',
		excerpt: 'Folge 24: Ausbildung, Fachkräftemangel und was Betriebe heute anders machen als vor zehn Jahren.',
		typeLabel: 'Podcast',
		imageSrc: IMG_A
	},
	{
		id: '8',
		title: 'Messebericht: Holz & Bau',
		category: 'Messe',
		date: '08.03.2026',
		excerpt: 'Stände, Trends und drei Produktneuheiten, die auf dem Rundgang für Tischler besonders relevant waren.',
		typeLabel: 'Bericht',
		imageSrc: IMG_B
	},
	{
		id: '9',
		title: 'Video: Kantenanleimer richtig einstellen',
		category: 'Fachwissen',
		date: '05.03.2026',
		excerpt: 'Kurzanleitung in fünf Minuten — Temperatur, Druck und Vorschub mit Checkliste zum Abhaken.',
		typeLabel: 'Video',
		imageSrc: IMG_A
	},
	{
		id: '10',
		title: 'FAQ Steuerliche Absetzbarkeit von Werkzeug',
		category: 'Recht & Steuern',
		date: '01.03.2026',
		excerpt:
			'Häufige Fragen zu AfA, Kleinwerten und Mischnutzung; ohne Rechtsberatung, mit Verweisen auf Finanzverwaltung.',
		typeLabel: 'Seite',
		imageSrc: IMG_B
	}
];
